import { Clear } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui-bundle/material';
import IconButton from '../IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const CloseButtonRoot = styled(IconButton)(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: theme.spacing(1.4),
  margin: theme.spacing(2),
  background: 'rgba(255,255,255,.75)'
}));
export const CloseButton = ({
  className,
  handleClick,
  variant,
  color
}) => /*#__PURE__*/_jsx(CloseButtonRoot, {
  variant: variant,
  color: color,
  className: className,
  onClick: handleClick,
  children: /*#__PURE__*/_jsx(Clear, {
    fontSize: "small",
    color: "inherit"
  })
});
//# sourceMappingURL=CloseButton.js.map